import {
  AtSign, Award, Badge, BadgeCheck, Bell, BookOpen, Box, BriefcaseBusiness, Building2,
  CalendarDays, CircleDot, DoorOpen, FileQuestion, FileText, GraduationCap, History,
  Image, Languages, Layers3, LifeBuoy, Link2, ListFilter, Mail, MapPin, MessageSquare,
  MessageSquareWarning, PanelsTopLeft, Paperclip, RefreshCw, RotateCcw, ScanLine,
  ScanSearch, Send, ShieldCheck, ShoppingBag, Sparkles, TrendingUp, Truck, UserCheck, UserRound, Users,
  type LucideIcon,
} from 'lucide-react'

const ICONS: Readonly<Record<string, LucideIcon>> = {
  record: CircleDot,
  'at-sign': AtSign,
  award: Award,
  badge: Badge,
  'badge-check': BadgeCheck,
  bell: Bell,
  'book-open': BookOpen,
  box: Box,
  'briefcase-business': BriefcaseBusiness,
  'building-2': Building2,
  'calendar-days': CalendarDays,
  'circle-dot': CircleDot,
  'door-open': DoorOpen,
  'file-question': FileQuestion,
  'file-text': FileText,
  'graduation-cap': GraduationCap,
  history: History,
  image: Image,
  languages: Languages,
  'layers-3': Layers3,
  'life-buoy': LifeBuoy,
  'link-2': Link2,
  'list-filter': ListFilter,
  mail: Mail,
  'map-pin': MapPin,
  'message-square': MessageSquare,
  'message-square-warning': MessageSquareWarning,
  'panels-top-left': PanelsTopLeft,
  paperclip: Paperclip,
  person: UserRound,
  'refresh-cw': RefreshCw,
  'rotate-ccw': RotateCcw,
  'scan-line': ScanLine,
  'scan-search': ScanSearch,
  send: Send,
  'shield-check': ShieldCheck,
  'shopping-bag': ShoppingBag,
  source: Link2,
  sparkles: Sparkles,
  /* #2502 (A7 via the lead, c.84058): the Elevate SPACE's section glyph on
     the portal rail — the design's rising-line mark. */
  'trending-up': TrendingUp,
  truck: Truck,
  'user-check': UserCheck,
  'user-round': UserRound,
  users: Users,
}

/** One renderer for governed entity icon keys; icons never replace text labels. */
export function EntityIcon({ iconKey, size = 18, className }: {
  iconKey?: string | null
  size?: number
  className?: string
}) {
  const key = iconKey?.trim() || 'record'
  const Icon = ICONS[key]
  if (Icon) return <Icon aria-hidden="true" focusable="false" size={size} className={className} />
  // Existing card declarations contain short typographic glyphs. Preserve them
  // while semantic word keys move through the shared registry above.
  if (key.length <= 3 || /[^a-z0-9-]/i.test(key)) {
    return <span aria-hidden="true" className={className}>{key}</span>
  }
  return <CircleDot aria-hidden="true" focusable="false" size={size} className={className} />
}
